
import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { TextField, FormControl, Select, MenuItem, InputLabel, Avatar } from "@mui/material";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "components/Navbars/DefaultNavbar";

// Routes
import routes from "routes";

// Images
import bgImage from "assets/images/school.jpg";
import useUploadImage from "hooks/imageContext";
import UserApi from "apis/UserApi";
import { useError } from "hooks/ErrorContext";
import { useSuccess } from "hooks/SuccessContext";

function UpdatePersonalDetails() {
  const { showError } = useError();
  const { showMessage } = useSuccess();
    const [formData, setFormData] = useState({

    mobile_num: "",
    address: "",
    occupation: "",
    speciality: "",
    private_info: false,
    profile_image: ""
  });

  const [media, setMedia] = useState(null);
  const [imgLoader, setImgLoader] = useState(false);
  const { uploadImage } = useUploadImage();
    const base_URL = process.env.REACT_APP_API_BASE_URL;



  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSwitchChange = (event) => {
    setFormData(prevState => ({
      ...prevState,
      private_info: event.target.checked
    }));
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (files) {
      try {
        setImgLoader(true);
        const data = await uploadImage(files, "ProfileImage");
        setMedia(data?.data?.[0]);
        setFormData(prevState => ({
          ...prevState,
          profile_image: data?.data?.[0]
        }));
      } catch (err) {
        console.log(err);
        // TODO: Add error handling
      }
      setImgLoader(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // TODO: Implement form submission logic
      console.log("Form submitted:", formData);
      try {
        await UserApi.updateUser(formData)
          showMessage("Profile updated successfully")
          const responseAPI = await  UserApi.getUserDetails()
          localStorage.setItem("user", JSON.stringify(responseAPI?.data?.data?.[0]));
      } catch (err) {
        console.log(err);
        showError("Failed to update profile")
      }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    setFormData(prevState => ({
      ...prevState,
      mobile_num: user?.mobile_num || "",
      address: user?.address || "",
      occupation: user?.occupation || "",
      speciality: user?.speciality || "",
      private_info: user?.private_info || false,
      profile_image: user?.profile_image || ""
    }));
    if (user?.profile_image) {
      setMedia(user.profile_image);
    }
  }, []);

  return (
    <>
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox px={2} width="100%" height="100vh" mx="auto" position="relative" zIndex={2}>
        <Grid container spacing={2} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={6} lg={7} xl={7}>
            <Card width="100%" sx={{backgroundColor:"#fff"}}>
              <MKBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={3}
                mb={2}
                textAlign="center"
              >
                <MKTypography variant="h4" fontWeight="bold" color="white" mt={1} sx={{textAlign:'left'}}>
                  Update Personal Details
                </MKTypography>
              </MKBox>
              <FormControl
                fullWidth
                component="form"
                onSubmit={handleSubmit}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  width: "100%",
                  margin: "0 auto",
                  mt: 5,
                  pt: 2,
                  pb: 3,
                  px: 3,
                }}
              >
                <MKBox display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <MKBox position="relative">
                    <Avatar
                      src={media ? `${base_URL}/get-image?objectKey=${media}` : ''}
                      alt="Profile"
                      sx={{
                        width: 120,
                        height: 120,
                        border: "4px solid white",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
                      }}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <MKButton
                      component="label"
                      htmlFor="image-upload"
                      variant="contained"
                      color="info"
                      size="small"
                      sx={{
                        position: "absolute",
                        bottom: 0,
                        right: 0,
                        minWidth: "auto",
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        padding: 0,
                        "& .material-icons": {
                          fontSize: "16px"
                        }
                      }}
                    >
                      <i className="fas fa-camera"></i>
                    </MKButton>
                  </MKBox>
                  {imgLoader && (
                    <MKTypography variant="caption" color="text">
                      Uploading...
                    </MKTypography>
                  )}
                </MKBox>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="mobile_num"
                      label="Mobile Number"
                      fullWidth
                      value={formData.mobile_num}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel id="occupation-label">Occupation</InputLabel>
                      <Select
                        name="occupation"
                        labelId="occupation-label"
                        label="Occupation"
                        value={formData.occupation}
                        onChange={handleInputChange}
                        style={{height: '43px'}}
                        required
                      >
                        {["Air Force", "Army", "Navy", "Doctor", "Engineer", "Businessman", "Other"].map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="address"
                      label="Address"
                      fullWidth
                      multiline
                      rows={3}
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="speciality"
                      label="Specialty"
                      fullWidth
                      value={formData.speciality}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.private_info}
                          onChange={handleSwitchChange}
                          name="sharePrivately"
                          color="primary"
                        />
                      }
                      label="Share information privately"
                    />
                  </Grid>
                </Grid>

                <MKBox mt={4} mb={1}>
                  <MKButton type="submit" variant="contained" color="info" fullWidth>
                    Update Details
                  </MKButton>
                </MKBox>
              </FormControl>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
    </>
  );
}

export default UpdatePersonalDetails;
